export default "/vendor/glyphicons-halflings-regular.b7c243015cec15850248814a6a37b2f4.ttf";